import React, { useState, useEffect } from 'react'
import { HomeContainer, SideBarMenuContainer } from './styles'
import { MainContent } from './MainContent'
import { SideBar } from './SideBar'
import { useWindowSize } from '../../hooks/useWindowSize'
import { HomeNavigationBar } from './HomeNavigationBar'
import { useGlobal } from '../../contexts/GlobalContext'
import { useData } from '../../contexts/DataContext'
import useToast from '../../hooks/useToast'
import { METHOD_TYPE } from '../../global/const'

export const Home = (props) => {
  const { searchText, method, onChangeMethod } = useData()
  const { showLoading, hideLoading } = useToast()
  
  const { invokeServer } = useGlobal()
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(true)
  const [isMoreView, setIsMoreView] = useState(false)
  const windowSize = useWindowSize()
  
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadMore, setIsLoadMore] = useState(false)
  const [categoryFilter, setCategoryFilter] = useState({})
  const [nftList, setNftList] = useState([])
  const [paginationProps, setPaginationProps] = useState({
    page_size: 15,
    current_page: 1
  })
  const [filterParams, setFilterParams] = useState({
    mintID: {
      minSetting: 0,
      maxSetting: 1000
    },
    price: {
      minSetting: 0,
      maxSetting: 1000
    }
  })

  const [filterValues, setFilterValues] = useState({
    category: {
      depth0: 'all',
      depth1: 'all',
      depth2: 'all'
    },
    price: [],
    currencyTypes: []
  })
  const [sortSelected, setSortSelected] = useState('recently_listed')

  const handleMoreView = () => {
    setIsMoreView(prev => !prev)
  }

  const handleCategoryClicked = (depth0, depth1, depth2, depth3, depth4) => {
    if (
      (categoryFilter.category0 === depth0) &&
      (categoryFilter.category1 === depth1) &&
      (categoryFilter.category2 === depth2) &&
      (categoryFilter.category3 === depth3) &&
      (categoryFilter.category4 === depth4)
    ) {
      setCategoryFilter(t => { return {} });
    } else {
      setCategoryFilter(t => {
        let tt = {};
        if (depth0) tt.category0 = depth0;
        if (depth1) tt.category1 = depth1;
        if (depth2) tt.category2 = depth2;
        if (depth3) tt.category3 = depth3;
        if (depth4) tt.category4 = depth4;

        return tt;
      })
    }
  }

  const handleChangeCurrency = (currency) => {
    let _currencyTypes = []
    const found = filterValues?.currencyTypes.find(type => type === currency)
    if (found !== undefined) {
      _currencyTypes = filterValues?.currencyTypes.filter(type => type !== currency)
    } else {
      _currencyTypes = [...filterValues?.currencyTypes]
      _currencyTypes.push(currency)
    }
    setFilterValues({
      ...filterValues,
      currencyTypes: _currencyTypes
    })
  }

  const handleChangeFilterItem = (name, value) => {
    setFilterValues({ ...filterValues, [name]: value })
  }

  const handleChangeFilterCategory = (name, value) => {
    const changes = { ...filterValues.category, [name]: value }
    setFilterValues({ ...filterValues, category: changes })
  }

  const getNftList = (page, page_size, newFetch = false) => {
    if (newFetch) setIsLoading(true)
    else setIsLoadMore(true)
    let where = null
    const categoryConditions = []
    const conditions = []

    if (searchText !== null) {
      const searchConditions = []
      searchConditions.push(
        {
          attribute: 'collectionName',
          value: {
            condition: 'i',
            value: searchText
          }
        }
      )
      searchConditions.push(
        {
          attribute: 'collectionAddress',
          value: {
            condition: 'i',
            value: searchText
          }
        }
      )
      if (method === METHOD_TYPE.DIRECT_SALE || method === METHOD_TYPE.AUCTION) {
        searchConditions.push(
          {
            attribute: 'sellerName',
            value: {
              condition: 'i',
              value: searchText
            }
          }
        )
        searchConditions.push(
          {
            attribute: 'seller',
            value: {
              condition: 'i',
              value: searchText
            }
          }
        )
      }
      if (method === METHOD_TYPE.UNLISTED) {
        searchConditions.push(
          {
            attribute: 'ownerName',
            value: {
              condition: 'i',
              value: searchText
            }
          }
        )
        searchConditions.push(
          {
            attribute: 'owner',
            value: {
              condition: 'i',
              value: searchText
            }
          }
        )
      }

      searchConditions.push(
        {
          attribute: 'tokenTitle',
          value: {
            condition: 'i',
            value: searchText
          }
        }
      )
      conditions.push({
        conector: 'OR',
        conditions: searchConditions
      })
    }

    if (Object.keys(filterValues).length) {
      if (filterValues?.currencyTypes?.length > 0) {
        conditions.push({
          attribute: 'payment',
          value: filterValues.currencyTypes
        })
      }

      if (filterValues?.price?.length > 0) {
        const priceConditions = []
        filterValues?.price.forEach(item => {
          const paymentConditions = []
          if (item?.max !== undefined && item?.min !== '') {
            paymentConditions.push(
              {
                attribute: 'price',
                value: {
                  condition: '>=',
                  value: parseFloat(item?.min)
                }
              }
            )
          }
          if (item?.max !== undefined && item?.max !== '') {
            paymentConditions.push(
              {
                attribute: 'price',
                value: {
                  condition: '<=',
                  value: parseFloat(item?.max)
                }
              }
            )
          }
          if (item?.payment) {
            paymentConditions.push(
              {
                attribute: 'payment',
                value: item?.payment
              }
            )
          }
          priceConditions.push({
            conector: 'AND',
            conditions: paymentConditions
          })
        })

        conditions.push({
          conector: 'OR',
          conditions: priceConditions
        })
      }

      if (filterValues?.category?.depth0 !== 'all') {
        categoryConditions.push({
          attribute: 'category0',
          value: filterValues?.category?.depth0
        })
      }
      if (filterValues?.category?.depth1 !== 'all') {
        categoryConditions.push({
          attribute: 'category1',
          value: filterValues?.category?.depth1
        })
      }
      if (filterValues?.category?.depth2 !== 'all') {
        categoryConditions.push({
          attribute: 'category2',
          value: filterValues?.category?.depth2
        })
      }
    }

    if (conditions.length) {
      where = {
        conditions,
        conector: 'AND'
      }
    }

    let fetchEndpoint = where
      ? `/api/nft?method=${method}&page=${page}&page_size=${page_size}&where=${JSON.stringify(where)}`
      : `/api/nft?method=${method}&page=${page}&page_size=${page_size}`

    if (categoryConditions.length > 0) {
      const category = { conditions: categoryConditions }
      fetchEndpoint = `${fetchEndpoint}&category=${JSON.stringify(category)}`
    }

    invokeServer('get', fetchEndpoint)
      .then(res => {
        if (!res.data.error) {
          if (newFetch) setNftList(res.data.result)
          else setNftList([...nftList, ...res.data.result])
          setPaginationProps(res.data.pagination)
        } else {
          console.log(res.data.result)
        }
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
      })
      .catch(err => {
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
        console.log(err)
      })
  }

  useEffect(() => {
    getNftList(1, paginationProps.page_size, true)
  }, [method, searchText, filterValues])

  useEffect(() => {
    if (isLoading) {
      showLoading(`Loading...`);
    } else {
      hideLoading()
    }
  }, [isLoading])

  return (
    <>
      <HomeContainer isOpenSideMenu={isOpenSideMenu}>
        {windowSize.width > 576 && (
          <SideBarMenuContainer style={isOpenSideMenu ? { width: '340px' } : { width: '64px' }}>
            <SideBar
              {...props}
              isMoreView={isMoreView}
              handleMoreView={handleMoreView}
              isOpenSideMenu={isOpenSideMenu}
              setIsOpenSideMenu={setIsOpenSideMenu}
              closeSideMenu={() => setIsOpenSideMenu(false)}
              handleCategoryClicked={handleCategoryClicked}
              filterParams={filterParams}
              setFilterParams={setFilterParams}
              filterValues={filterValues}
              setFilterValues={setFilterValues}
              handleChangeCurrency={handleChangeCurrency}
              handleChangeFilterItem={handleChangeFilterItem}
              handleChangeFilterCategory={handleChangeFilterCategory}
              method={method}
              onChangeMethod={onChangeMethod}
            />
          </SideBarMenuContainer>
        )}
        <MainContent
          isOpenRightMenu={isOpenSideMenu}
          isMoreView={isMoreView}
          isLoading={isLoading}
          nftList={nftList}
          getNftList={getNftList}
          paginationProps={paginationProps}
          isLoadMore={isLoadMore}
          setIsLoadMore={setIsLoadMore}
          setIsMoreView={setIsMoreView}
          sortSelected={sortSelected}
          setSortSelected={setSortSelected}
          method={method}
        />
      </HomeContainer>
      {windowSize.width < 576 && <HomeNavigationBar
        isMoreView={isMoreView}
        handleMoreView={handleMoreView}
        isOpenSideMenu={isOpenSideMenu}
        setIsOpenSideMenu={setIsOpenSideMenu}
        closeSideMenu={() => setIsOpenSideMenu(false)}
        handleCategoryClicked={handleCategoryClicked}
        filterParams={filterParams}
        setFilterParams={setFilterParams}
      />}
    </>
  )
}
